<template>
    <div class="video-grids" ref="videoGridsRef">
        <div class="video-grids__header">
            <div class="video-grids__header-left">
                <div v-if="showTree" class="video-grids__header-item item-margin">
                    <el-dropdown trigger="hover" placement="bottom">
                        <span class="flex-center" style="color: #fff;">
                            <span>{{ $t('home.middle.video.videoList') }}</span>
                            <span>
                                <i class="el-icon-caret-bottom"></i>
                            </span>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="c-el-popover-blue opacity-1 video-tree-dropdown ">
                            <div style="width: 240px;min-height: 200px;">
                                <el-tree ref="treeRef" :data="treeDataList" :default-expanded-keys="defaultExpandedKeys"
                                    v-bind="treeProps" @node-click="handleOnNodeClick"></el-tree>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <slot name="title" v-if="showTitle">
                    <span>{{ title }}</span>
                </slot>
                <!-- 头部左侧额外内容下拉选择插槽 -->
                <slot name="headerLeftExtra">
                </slot>
                <!-- 头部左侧额外内容之后历史视频插槽 -->
                <slot name="headerLeftExtraAfter">
                </slot>
            </div>
            <div class="video-grids__header-right">
                <div v-for="item in videoCountOptions" :key="item.value" class="video-grids__header-item"
                    :class="{ 'is-active': screenCount === item.value }" @click="handleChangeGridCount(item.value)">
                    <div class="video-count-icon" :style="getGridStyle(item.value)">
                        <span v-for="i in item.value" :key="i" class="icon-grid"></span>
                    </div>
                    <span>{{ item.label }}</span>
                </div>
                <div class="video-grids__header-item" @click="toggleFullScreen">
                    <span class="video-count-icon">
                        <i :class="['iconfont', isFullScreen ? 'icon-fullscreen-exit' : 'icon-fullscreen']"></i>
                    </span>
                    <span>{{ $t('home.middle.video.fullScreen') }}</span>
                </div>
            </div>
        </div>
        <div class="video-grids__content" :style="videoGridContentStyle">
            <div v-for="(item, index) in gridVideoList" :key="`${item ? item.src || item.url : ''}_${index}`"
                class="video-grid" :class="{ 'is-selected': selectedGridIndex === index }" @click="selectGrid(index)">
                <div v-if="item" class="video-grid__body">
                    <CVideo :info="item.info || {}" :title="item.name" :src="item.src || item.url" />
                </div>
                <div v-else class="video-grid__empty">
                    <slot name="empty">
                        <span> {{ emptyText }}</span>
                    </slot>
                </div>
            </div>

            <span v-if="page > 1" class="i-prev" @click.stop="prevClick"></span>
            <span v-if="page < totalPage" class="i-next" @click.stop="nextClick"></span>
        </div>
    </div>
</template>

<script>
/**
 * 视频宫格组件
 */
import CVideo from '@/page/mainPage/components/Video.vue';
import FullScreenUtil from '@/utils/fullscreen';

export default {
    name: 'VideoGrid',
    components: {
        CVideo,
    },
    props: {
        videoList: {
            type: Array,
            default: () => [
                // { src: "", info: {} }
            ],
        },
        /**
         * 应急案件列表树状结构数据
        */
        treeData: {
            type: Array,
            default: () => [
                // { src: "", info: {} }
            ],
        },
        showTree: {
            type: Boolean,
            default: false,
        },
        /**
         * 所有应急案件列表
        */
        allCeseList: {
            type: Array,
            default: () => [],
        },
        /**
         * 活动ID
        */
        activityId: {
            type: String,
            default: '',
        },
        treeProps: {
            type: Object,
            default: () => ({
                props: {
                    nodeKey: 'id',
                    children: 'children',
                    label: 'label',
                },

            }),
        },
        gutter: {
            type: Number,
            default: 4,
        },
        title: {
            type: String,
            default: '视频墙',
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        emptyText: {
            type: String,
            default: '暂无视频',
        },
        // 默认视频宫格分屏数量
        splitCount: {
            type: Number,
            default: 4,
        },
        // 最大分屏数量
        maxSplitCount: {
            type: Number,
            default: 9,
        },
    },

    data() {
        return {
            gridVideoList: [],
            screenCount: this.splitCount,
            page: 1,
            isFullScreen: false,
            selectedGridIndex: -1, // 选中的索引
            treeDataList: [],
            defaultExpandedKeys: [],
            checkedNodeData: null,
            selectedCaseId: null,
        };
    },
    computed: {
        videoCountOptions() {
            let list = [
                {
                    label: this.$t('home.middle.video.singleView'),
                    value: 1,
                },
                {
                    label: this.$t('home.middle.video.quadView'),
                    value: 4,
                },
                {
                    label: this.$t('home.middle.video.sixWayView'),
                    value: 6,
                },
                {
                    label: this.$t('home.middle.video.nineWayView'),
                    value: 9,
                    disabled: false,
                },
            ];
            return list.filter((item) => !item.disabled && item.value <= this.maxSplitCount);
        },
        totalPage() {
            return Math.ceil(this.videoList.length / this.screenCount);
        },

        videoGridContentStyle() {
            const screenCount = this.screenCount;
            const gridSize = Math.sqrt(screenCount); // 例如 4 -> 2, 9 -> 3
            let columns = gridSize;
            let rows = gridSize;
            if (screenCount === 6) {
                columns = 2;
                rows = 3;
            } else if (screenCount === 8) {
                columns = 2;
                rows = 4;
            }
            let sty = {
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gridTemplateRows: `repeat(${rows}, 1fr)`,
                gap: `${this.gutter}px`,
            };

            return sty;
        },
    },
    methods: {

        handleChangeGridCount(value) {
            this.screenCount = value;
            this.initGridVideoList();
            this.updateGridVideoList();
        },
        // 根据 value 计算几行几列
        getGridStyle(value) {
            const gridSize = Math.sqrt(value); // 例如 4 -> 2, 9 -> 3
            const screenCount = value;
            let columns = gridSize;
            let rows = gridSize;
            if (screenCount === 6) {
                columns = 2;
                rows = 3;
            } else if (screenCount === 8) {
                columns = 2;
                rows = 4;
            }

            return {
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gridTemplateRows: `repeat(${rows}, 1fr)`,
                gap: '2px',
            };
        },
        /**
     * 切换全屏状态
     *
     * 该方法用于切换指定元素的全屏状态。
     *
     * @method toggleFullScreen
     */
        toggleFullScreen () {
            this.isFullScreen = !this.isFullScreen;
            FullScreenUtil.toggleFullScreen(this.$refs.videoGridsRef);
        },
        /**
     * 初始化视频宫格列表
     *
     * 该方法用于初始化视频宫格列表，根据当前屏幕数量设置宫格数量，并将每个宫格初始化为 null。
     *
     * @method initGridVideoList
     */
        initGridVideoList () {
            this.selectedGridIndex = -1;
            let result = [];
            for (let i = 0; i < this.screenCount; i++) {
                result.push(null);
            }
            this.gridVideoList = result;
        },
        /**
    * 更新视频宫格列表
    *
    * 根据当前页的视频列表，将其中的视频依次填充到非自定义格子；
    * 保留自定义格子内容，且多余的视频不会放入；
    * 同时避免重复添加已经在宫格中的视频。
    */
        updateGridVideoList () {
            // 拷贝宫格列表
            let cloneGridVideoList = [...this.gridVideoList];

            // 移除不存在的视频（保持长度）
            const videoSrcSet = new Set(this.videoList.map((v) => v.src || v.url));
            cloneGridVideoList = cloneGridVideoList.map((item) => {
                if (!item) return null;
                const existSrc = item.id || item.src || item.url;
                return videoSrcSet.has(existSrc) ? item : null;
            });

            // 当前页视频
            const pageSize = this.screenCount;
            const currentPage = this.page;
            const startIndex = (currentPage - 1) * pageSize;
            const endIndex = startIndex + pageSize;
            // ✅ 去重：移除已在宫格中的视频
            const gridVideoSrcSet = new Set(
                cloneGridVideoList.filter(Boolean).map((v) => v.id || v.src || v.url),
            );
            let list = [];
            list = this.videoList.filter((v) => !gridVideoSrcSet.has(v.id || v.src || v.url));

            list = this.videoList.slice(startIndex, endIndex);

            // 指向 list 当前使用到的视频索引
            let listIndex = 0;

            // 遍历宫格，依次填充非自定义格子
            cloneGridVideoList = cloneGridVideoList.map((gridVideo) => {
                // 保留自定义格子
                if (gridVideo?.isCustom) return gridVideo;

                // 如果还有可用的视频，就放进去
                if (listIndex < list.length) {
                    const newVideo = { ...list[listIndex] };
                    listIndex++;
                    return newVideo;
                }

                // 没有可放的视频则保持原状或空
                return gridVideo ?? null;
            });

            this.gridVideoList = cloneGridVideoList;
        },

        selectGrid (index) {
            this.selectedGridIndex = this.selectedGridIndex === index ? -1 : index;
        },
        // 上一页
        prevClick () {
            if (this.page > 1) {
                this.page--;
            }
            this.initGridVideoList();
            this.updateGridVideoList();
        },
        // 下一页
        nextClick () {
            if (this.page < this.totalPage) {
                this.page++;
            }
            this.initGridVideoList();
            this.updateGridVideoList();
        },
        /**
     * 处理节点点击事件
     *
     * 该方法在节点被点击时调用，根据节点的类型和选中状态来更新视频列表。
     *
     * @method handleOnNodeClick
     * @param {Object} nodeData - 节点数据对象，包含节点的属性和信息。
     * @param {Object} node - 节点对象，包含节点的属性和方法。
     * @param {Object} instance - 组件实例对象，用于访问组件的属性和方法。
     */
        handleOnNodeClick(nodeData, node, instance) {
            // this.checkedNodeData = nodeData
            // this.$emit('node-click', nodeData, node, instance)
            let cloneGridVideoList = [].concat(this.gridVideoList);
            if (this.selectedGridIndex !== -1) {
                if (node.isLeaf && !nodeData.nodeType) {
                    let obj = { ...nodeData, isCustom: true };
                    cloneGridVideoList[this.selectedGridIndex] = obj;
                    this.gridVideoList = cloneGridVideoList;
                    if (this.selectedGridIndex < this.gridVideoList.length - 1) {
                        this.selectedGridIndex++;
                    } else {
                        this.selectedGridIndex = -1;
                    }
                }
            } else if (node.isLeaf && !nodeData.nodeType) {
                for (let i = 0; i < this.gridVideoList.length; i++) {
                    let item = this.gridVideoList[i];
                    if (!item) {
                        let obj = { ...nodeData, isCustom: true };
                        cloneGridVideoList[i] = obj;
                        this.gridVideoList = cloneGridVideoList;
                        break;
                    }
                }
            }
        },
        // ✅ 1️⃣ 获取当前展开节点 key 列表
        getExpandedKeys() {
            const tree = this.$refs.treeRef;

            if (!tree || !tree.store || !tree.store.nodesMap) return [];

            const keys = [];
            Object.values(tree.store.nodesMap).forEach((node) => {
                if (node.expanded) keys.push(node.key);
            });
            return keys;
        },
    },
    created() {
        this.initGridVideoList();
    },
    mounted() {
        this.removeFullScreenListener = FullScreenUtil.onFullScreenChange((isFull) => {
            if (isFull) {
                this.isFullScreen = true;
            } else {
                this.isFullScreen = false;
            }
        });
    },
    beforeDestroy() {
        if (typeof this.removeFullScreenListener === 'function' && this.removeFullScreenListener !== null) {
            // 需要时移除监听事件
            this.removeFullScreenListener();
        }
    },
    watch: {
        treeData: {
            handler(newVal) {
                if (newVal) {
                    // 目的是解决展开树结构后，如果treeData 是在外部通过computed 计算的会变化时，treeData 变化会导致展开的节点会重新被折叠，这里先获取当前展开的节点key列表，再通过设置defaultExpandedKeys让原来的节点展开
                    const expandedKeys = this.getExpandedKeys();
                    this.defaultExpandedKeys = expandedKeys;
                    this.treeDataList = newVal;
                }
            },
            deep: true,
        },
        videoList: {
            handler(newVal) {
                if (newVal) {
                    this.updateGridVideoList();
                }
            },
            deep: true,
        },
        splitCount(newVal) {
            if (newVal) {
                this.screenCount = newVal;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$colorLight: #5bf0fc;

.video-grids {
    height: 100%;

    .video-grids__header {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-left,
        &-right {
            display: flex;
            align-items: center;
        }

        .item-margin {
            margin-right: 12px;
        }

        &-case,
        &-share,
        &-history {
            margin-right: 12px;
        }

        &-title {
            font-size: 14px;
            font-weight: 500;
            color: #fff;
            flex: 1
        }

        .video-grids__header-list {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;

        }

        .video-grids__header-item {
            cursor: pointer;
            display: inline-flex;
            align-items: center;

            &+.video-grids__header-item {
                margin-left: 6px;
            }

            &.is-active {
                color: $colorLight;

                .icon-grid {
                    background-color: $colorLight;

                }
            }
        }

        .video-count-icon {
            width: 16px;
            height: 16px;
            background-color: rgba(255, 255, 255, 0.1);
            overflow: hidden;
            margin-right: 4px;
        }

        .icon-grid {
            background-color: #fff;

        }

    }

    &__content {
        display: grid;
        position: relative;
        height: calc(100% - 36px);

        .video-grid {
            position: relative;
            // aspect-ratio: 4 / 3; // 宽高比固定为 4:3
            width: 100%;
            border: 1px solid #1a47a4;
            background-color: rgba(26, 71, 164, 0.4);

            &.is-selected {
                border-color: red;
            }

            ::v-deep .c-videolist-video__title {
                font-size: 12px;
                height: 24px;
                line-height: 24px;
            }
        }

        .video-grid__body {
            position: relative;
            height: 100%;
        }

        .video-grid__empty {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
        }

        .i-prev,
        .i-next {
            position: absolute;
            display: inline-block;
            top: 50%;
            transform: translateY(-50%);
            width: 30px;
            height: 30px;
            z-index: 10;
            cursor: pointer;
            overflow: hidden;
            background-size: contain;
            /* 保证图像完全显示 */
            background-repeat: no-repeat;
            /* 防止背景图重复 */
            background-position: center;
            /* 使背景图居中显示 */
        }

        .i-prev {
            background-image: url('~@/page/mainPage/components/imgs/video/page_left.png');
        }

        .i-next {
            right: 0px;
            background-image: url('~@/page/mainPage/components/imgs/video/page_right.png');
        }
    }
}
</style>
<style lang="scss" scoped>
.video-tree-dropdown {

    .el-tree {
        background: inherit;
        color: #fff;
    }
}

.video-case-select {
    .el-select-dropdown__item {
        color: #fff;

        &:hover {
            background-color: rgba(73, 240, 253, 0.2);
            color: #49f0fd;
        }

        &.is-selected {
            background-color: rgba(73, 240, 253, 0.2);
            color: #49f0fd;
        }
    }
}

.video-grids__header-case {
    ::v-deep .el-select {
        .el-input__inner {
            background-color: rgba(255, 255, 255, 0.1);
            border-color: rgba(73, 240, 253, 0.3);
            color: #fff;

            &:hover {
                border-color: #49f0fd;
            }
        }

        .el-input__icon {
            color: #fff;
        }
    }
}
</style>
